/**
 =========================================================
 * Material Dashboard 2 React - v2.2.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-dashboard-react
 * Copyright 2023 Creative Tim (https://www.creative-tim.com)

 Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

import * as React from 'react';

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

import MDInput from "../../../components/MDInput";
import PropTypes from "prop-types";
import DataTable from "../../../examples/Tables/DataTable";
import data from "../../dashboard/components/Projects/data";
import { useEffect, useState } from "react";
import Icon from "@mui/material/Icon";
import NewMerchantGroupUser from "./newMerchantGroupUser";
import useApi from "../../../components/Utils/api";
import PermissionControl from "../../../components/Utils/PermissionControl";


function MerchantGroupUsers(props) {
  const {merchantGroup, merchantGroups, openConfigurator, setOpenConfigurator, user, setUser} = props;
  const { merchatnUsersTablecolumns } = data();

  const [users, setUsers] = useState([]);
  const api = useApi();

  function updateUserHandler(item) {
    setOpenConfigurator(true);
    setUser(item);
  }

  function handleConfirmDelete(item) {
    return;
  }

  const getMerchantGroupUsers = () => {
    const data = {
      referenceId: merchantGroup.referenceId
    }
    api.post("admin/browseSingleMerchantGroupUsers", data)
      .then(response => {
        if(response.data.body.length > 0 ){
          const modifiedData = response.data.body.map((item, index) => {
            const id = index;
            const action = (
                <PermissionControl permission={{ restrict: true, module: "User", subModule: "UpdateOrganizationUser" }}>
                  <MDBox display="flex" alignItems="center" lineHeight={1}>
                    <Icon fontSize="small" style={{cursor : 'pointer'}} onClick={(e) => { e.stopPropagation(); updateUserHandler(item); }}>create</Icon>
                  </MDBox>
                </PermissionControl>
            );
            return { ...item, action, id };
          });
          console.log(modifiedData);
          setUsers(modifiedData);
        } else {
          setUsers([]);
        }
      })
      .catch(error => {
        console.log(error.response.data);
      });
  }

  useEffect(() => {
    if (merchantGroup.hasOwnProperty("referenceId")) getMerchantGroupUsers();
  }, [merchantGroup]);
  useEffect(() => {
    if (merchantGroup.hasOwnProperty("referenceId") && openConfigurator === false) getMerchantGroupUsers();
  }, [openConfigurator]);

  return (
    <Grid mt={3} mb={3}>
      <Grid container spacing={3} justifyContent="center">
        <Grid item xs={12}>
          <MDBox sx={(theme) => ({ border: `1px solid ${theme.palette.grey[300]}`, borderRadius: "8px", background: theme.palette.white.main, overflow: "hidden" })}>
            <DataTable
              table={{ columns : merchatnUsersTablecolumns, rows : users }}
              showTotalEntries={true}
              isSorted={true}
              noEndBorder
              entriesPerPage={true}
              entriesPerPagePosition="bottom"
              canSearch={false}
            />
          </MDBox>
        </Grid>
        <NewMerchantGroupUser openConfigurator={openConfigurator} setOpenConfigurator={setOpenConfigurator} merchant={merchantGroup} merchantGroups={merchantGroups} user={user} />
      </Grid>
    </Grid>
  );
}

MerchantGroupUsers.defaultProps = {
  merchantGroup: false,
  merchantGroups: [],
  openConfigurator: false,
  user: {},
}

MerchantGroupUsers.propTypes = {
  merchantGroup: PropTypes.any.isRequired,
  merchantGroups: PropTypes.array,
  openConfigurator: PropTypes.bool,
  setOpenConfigurator: PropTypes.func.isRequired,
  user: PropTypes.any,
  setUser: PropTypes.func.isRequired,
}

export default MerchantGroupUsers;
